import { request } from "../../apis";
import { getUserCurrency } from "../../plugins/utils";

const userCurrency = getUserCurrency()

export const apiGetUserInfo = (params) =>
  request("get", `/${userCurrency}/agent/info`, params, true);
